// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_yu","pin":"e_zu","tip":"e_Au","wrapOpen":"e_Bu"};